import { TGeoValue } from '@cian/api-models/common/json_query';
import { pathOr } from 'ramda';
import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import {
  TSuggestResult,
  IYandexSuggestOptions,
  suggest,
  selectGeo,
  clearGeo,
  geocode,
  setRegion,
  setVillage,
  setBSCenters,
  setBuilder,
  setCoworkingIds,
} from '../../actions/filters';
import { FilterGeo, IFilterGeoProps } from '../../components/FilterGeo';
import { getGeoBbox } from '../../actions/filters/geo/getGeoBoundedBy';

type TFilterGeoStateProps = Pick<IFilterGeoProps, 'pageKind' | 'regionOrMaintownId' | 'suggestions' | 'jsonQuery'>;
type TFilterGeoDispatchProps = Pick<
  IFilterGeoProps,
  | 'getGeoBbox'
  | 'getSuggestions'
  | 'setRegion'
  | 'setVillage'
  | 'setBSCenters'
  | 'selectGeo'
  | 'geocode'
  | 'clearGeo'
  | 'setBuilder'
  | 'setCoworkingIds'
>;

export function mapStateToProps(state: IReduxState): TFilterGeoStateProps {
  return {
    pageKind: state.page.kind,
    jsonQuery: state.filters.jsonQuery,
    suggestions: state.filters.suggestions,
    regionOrMaintownId: pathOr(state.userGeo.userGeo, ['region', 'value'], state.filters.jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): TFilterGeoDispatchProps {
  return {
    getGeoBbox: (regionOrMaintownId: number) => dispatch(getGeoBbox(regionOrMaintownId)),
    getSuggestions: (query: string, options?: IYandexSuggestOptions): Promise<TSuggestResult> => {
      return dispatch(suggest({ query, options }));
    },
    setRegion: (region: number[]) => dispatch(setRegion(region)),
    setVillage: (villageId: number | undefined) => dispatch(setVillage(villageId)),
    setBSCenters: (bsCenterIds: number[]) => dispatch(setBSCenters(bsCenterIds)),
    selectGeo: (geoValue: TGeoValue) => dispatch(selectGeo(geoValue)),
    geocode: (query: string): Promise<TGeoValue> => dispatch(geocode({ query })),
    clearGeo: () => dispatch(clearGeo()),
    setBuilder: (builderId: number) => dispatch(setBuilder(builderId)),
    setCoworkingIds: (coworkingIds: number[]) => dispatch(setCoworkingIds(coworkingIds)),
  };
}

export const FilterGeoContainer = connect(mapStateToProps, mapDispatchToProps)(FilterGeo);
